// Hackathon Website Template

import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App" style={{ backgroundColor: '#121212', color: '#ffffff', minHeight: '100vh', padding: '20px' }}>
      <header className="App-header">
        <h1>AI & ML Hackathon 2023</h1>
        <p>Join us for an exciting journey into the world of Artificial Intelligence and Machine Learning!</p>
      </header>
      <main>
        <section>
          <h2>About the Hackathon</h2>
          <p>Compete with the best minds and showcase your skills in AI and ML.</p>
        </section>
        <section>
          <h2>Registration Form</h2>
          <form>
            <label>
              Name:
              <input type="text" name="name" required />
            </label>
            <br />
            <label>
              Email:
              <input type="email" name="email" required />
            </label>
            <br />
            <label>
              Team Name:
              <input type="text" name="teamName" required />
            </label>
            <br />
            <button type="submit">Register</button>
          </form>
        </section>
      </main>
      <footer>
        <p>&copy; 2023 AI & ML Hackathon. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
